export const ErrorModuleNames = {
    SESSION_RHS: 'SessionRHS',
    RHS: 'RHS',
    BOOTHS: 'Booths',
    SOCIAL_LOUNGE: 'SocialLounge',
    SESSIONS: 'Sessions',
    LIVE_STAGE: 'LiveStage',
    SPEED_NETWORKING: 'SpeedNetworking',
    SCHEDULED_MEETING: 'ScheduledMeeting',
    RECEPTION: 'Reception',
    FLUID_SPACE: 'FluidSpace',
    LIVE_SESSION_BREAKOUT: 'LiveStage:LiveSessionBreakout',
    BREAKOUT_CREATION: 'LiveStage:BreakoutCreation',
    BREAKOUT_RHS: 'LiveStage:BreakoutRHS',
};
export const dashboardModuleNames = {
    SUMMARY: 'Dashboard:Summary',
    SESSIONS: 'Dashboard:SessionsTab',
    SPEAKERS_HOST: 'Dashboard:SpeakersHosts',
    TICKETS: 'Dashboard:Tickets',
    ACCESS_RULES_V2: 'Dashboard:RulesV2',
    ACCESS_RULES_V1: 'Dashboard:RulesV1',
    STAGE_BACKDROP: 'Dashboard:StageBackdrop',
    PRE_RECORDED_VIDEO: 'Dashboard:Video',
    MANAGE_RECORDING: 'Dashboard:Recordings',
    LIVE_STREAM_V2: 'Dashboard:LiveStreamTabV2',
    LIVE_STREAM_V1: 'Dashboard:LiveStreamTabV1',
    SUMMIT_SPONSORS: 'Dashboard:Sponsors',
    BRANDING: 'Dashboard:Branding',
    BOOTHS: 'Dashboard:Booths',
    VENUE_SETTINGS: 'Dashboard:Venue',
    AUDIENCE: 'Dashboard:AudienceTab',
    ANALYTICS: 'Dashboard:AnalyticsTab',
    LEADERBOARD: 'Dashboard:Leaderboard',
    EVENT_INTEGRATIONS: 'Dashboard:EventIntegrations',
    DASHBOARD_SIDE_MENU: 'Dashboard:DashboardSideMenu',
    INTEGRATION_DETAILS: 'Dashboard:IntegrationDetails',
    PRE_EVENT_ENTRY: 'Dashboard:PreEventEntry',
    POST_EVENT_ENTRY: 'Dashboard:PostEventEntry',
    // subtabs
    PARTICIPANT: 'Dashboard:ParticipantTab',
    EMAIL_MANAEMENT: 'Dashboard:EmailManagement',
    ANALYTICS_REGISTRATION: 'Dashboard:AnalyticsRegistration',
    ANALYTICS_ENGAGEMENT: 'Dashboard:AnalyticsEngagement',
    INTEGRATION_APPS: 'Dashboard:IntegrationApps',
    LIVE_STREAM_DESTINATION: 'Dashboard:LiveStreamDestination',
    API_ACCESS_KEY: 'Dashboard:ApiAccessKey',
    // Community dashboard items.
    EVENTS_TAB: 'Dashboard:EventsTab',
    VIDEO_LIBRARY: 'Dashboard:VideoLibrary',
    TEAMS: 'Dashboard:TeamsTab',
    APPSUMO_PLANS: 'Dashboard:AppSumoPlan',
    SETTINGS: 'Dashboard:Settings',
    BILLING_PLAN: 'Dashboard:BillingPlan',
    GETTING_STARTED: 'Dashboard:GettingStarted',
    CURRENT_BILLING_PLAN: 'Dashboard:CurrentBillingPlan',
    // Some generic componentDashboard:
    GENERAL_DRAWER: 'Drawer',
    EVENT_DASHBOARD_HOME: 'Dashboard:EventDashboardHome',
    INTRO_VIDEO_PLAYR: 'Dashboard:IntroVideoPlayer',
};
